import { RecorderConfig } from "./types";

const config: Required<RecorderConfig> = {
  waveColor: "#007bff",
  progressColor: "#8c92a4",
  rangeColor: "#14df42",
  size: { width: 280, height: 110 },
};

export default config;
